import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Elements from './components/elements';
import NotFound from './components/notFound';
import Main from './components/landingPage/main';
import Dashboard from './components/dashboard/dashboardMain';
import Schedule from './components/schedule/scheduleMain';

class App extends Component {
  state = {
    services: [],
  };

  render() {
    return (
      <React.Fragment>
        <Switch>
          <Route
            path="/schedule"
            component={(props) => (
              <Schedule
                onPrev={this.handlePrev}
                onNext={this.handleNext}
                onInput={this.handleInput}
                {...props}
              />
            )}
          />
          <Route path="/dashboard" component={Dashboard} />
          <Route path="/elements" component={Elements} />
          <Route path="/not-found" component={NotFound} />
          <Route path="/" exact component={Main} />
          <Redirect to="not-found" />
        </Switch>
      </React.Fragment>
    );
  }
}

export default App;
